import { Box, Button, Flex, Heading, Stack, Text } from "@chakra-ui/react";
import React from "react";

export default function Banner() {
  return (
    <Flex
      bgImage={{
        base: "url('/images/become-a-seller/banner-mobile.png')",
        md: "url('/images/become-a-seller/banner.png')",
      }}
      height={{ base: "270px", md: "550px" }}
      bgSize={"cover"}
      bgRepeat="no-repeat"
      justifyContent={"center"}
      alignItems="start"
      flexDirection="column"
      color="white"
      gap={5}
      backgroundPosition="center"
      mb={10}
    >
      <Stack
        gap={{ base: 2, md: 6 }}
        color="white"
        ml={{ base: "6%", md: "10%",xl:"15%" }}
        width={{ base: "50%", md: "520px" }}
      >
        <Heading
          fontSize={{ base: "24px", md: "36px" }}
          fontWeight={"semibold"}
        >
          Become a Seller
        </Heading>
        <Text fontSize={{ base: "12px", md: "24px" }} fontWeight={"semibold"}>
          You'll bring the skill, we'll make the earning easy
        </Text>
        <Box>
          <Button
            bg="brand.100"
            fontSize={{ base: "13px", md: "16px" }}
            py={{ base: 4, md: 6 }}
            borderRadius={10}
            width={{ base: "140px", md: "200px" }}
          >
            Get Started
          </Button>
        </Box>
      </Stack>
    </Flex>
  );
}
